export const useStyles = (theme) => ({
  tableStyle: {
    border: `1px solid #181818`,
  },
});
